.social-medias {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.social-medias li {
  list-style: none;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  transition: all .3s;
  cursor: pointer;
}
.social-medias li:hover {
  background: rgba(255,255,255,.09);
}
.social-medias li a {
  display: inline-block;
  height: 20px;
}
.social-medias li svg {
  height: 20px;
  width: 20px;
}



.social-medias li .popup {
  display: none;
  position: absolute;
  bottom: 26px;
  right: -5px;
  width: 144px;
  height: 160px;
}
.social-medias li .popup .er-code {
  padding: 4px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
}
.social-medias li .popup .er-code img {
  width: 136px;
  height: 136px;
  display: block;
}
.social-medias li .popup .triangle {
  position: absolute;
  background: #fff;
  box-shadow: 4px 4px 8px rgba(0,0,0,.1);
  z-index: 8;
  width: 11px;
  height: 11px;
  bottom: 16px;
  right: 16px;
  transform: translateY(50%) rotate(45deg);
}
